<template>
    <div>
		<p>	</p>
        <!-- <h1>ECS Task Sync</h1> -->
        <!-- Data Sync Section -->
		<v-card class="mb-4">
			<v-card-title class="d-flex align-center justify-space-between">
				<div class="d-flex align-center">
					<span>API Data Sync</span>
				</div>
				<!-- School Mapping Button - Only show for district level -->
				<SchoolMappingButton 
					v-if="schoolStore.school?.is_district == 'yes'" 
					:integration_type="props.integration_type" 
				/>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<v-select
							v-model="selectedEntities"
							:items="getEntityOptions"
							item-title="title"
							item-value="value"
							label="Select Entities to Sync"
							multiple
							chips
							closable-chips
							variant="outlined"
							density="comfortable"
						></v-select>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions>
				<!-- Sync Logs/Status Button -->
				<SyncLogs :integration_type="props.integration_type" />
				<v-spacer />
				
				<v-btn
					color="primary"
					:disabled="!props.hasValidConfig || !selectedEntities.length || syncing"
					:loading="syncing"
					variant="elevated"
					@click="startSync(selectedEntities)"
				>
					Sync Selected Data
				</v-btn>
				<!-- Sync Progress Bar -->
			</v-card-actions>
			<v-progress-linear
				indeterminate
				color="secondary"
				v-if="syncing"
			></v-progress-linear>
		</v-card>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import SyncLogs from '@/components/school/integration/SyncLogs.vue';
import SchoolMappingButton from '@/components/school/integration/SchoolMappingButton.vue';
import { useSyncStatus } from '@/composables/useSyncStatus';
import { useSchoolStore } from '@/stores/school';

// Define props
interface Props {
	integration_type?: string;
	hasValidConfig?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	integration_type: "1.1",
	hasValidConfig: true
});

// Use the sync status composable
const { syncLogs, syncing, startSync, fetchSyncStatus } = useSyncStatus(props.integration_type);

const schoolStore = useSchoolStore();
const isDistrict = computed(() => schoolStore.isDistrict());

const selectedEntities = ref<string[]>([]);


const getEntityOptions = computed(() => {
	if (props.integration_type == "facts") {
		return [
			{ title: "Students", value: "students" },
			{ title: "Person", value: "person" },
			{ title: "Family", value: "family" },
			{ title: "Course", value: "course" },
			{ title: "Classroom", value: "classroom" },
			{ title: "Enrollment", value: "enrollment" },
		];
	} else if (props.integration_type == "nycdoe") {
		return [
			{ title: "Students", value: "students" },
			{ title: "Courses", value: "courses" },
			{ title: "Classes", value: "classes" },
			{ title: "Teachers", value: "teachers" },
			{ title: "Student Enrollment", value: "student_enrollment" },
			{ title: "Teacher Enrollment", value: "teacher_enrollment" },
		];
	} else {
		return [
			{ title: "Students", value: "students" },
			{ title: "Courses", value: "courses" },
			{ title: "Classes", value: "classes" },
			{ title: "Teachers", value: "teachers" },
			{ title: "Parents", value: "parents" },
			{ title: "Student Enrollment", value: "student_enrollment" },
			{ title: "Teacher Enrollment", value: "teacher_enrollment" },
			{ title: "Schools", value: "schools" },
		];
	}
});



onMounted(async () => {
	selectedEntities.value = getEntityOptions.value.map((option) => option.value);
	// Fetch initial sync status
	await fetchSyncStatus();
});
</script>

<style scoped lang="scss">  
</style>